'use client'

import { CAPTCHA_SITE_KEY } from '@/lib/constants'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

export const CaptchaProvider = ({ children }: any) => {
  return <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_SITE_KEY}>{children}</GoogleReCaptchaProvider>
}
